import { productApi } from './product.api';

export const productActions = {
  async getProducts({ commit }, payload) {
    try {
      commit('GET_PRODUCTS_LOADING');
      const response = await productApi.getProducts(payload);
      commit('GET_PRODUCTS_SUCCESS', response.data);
      return response;
    } catch (error) {
      commit('GET_PRODUCTS_ERROR', error.response);
    }
  },
  async getProduct({ commit }, id) {
    try {
      commit('GET_PRODUCT_LOADING');

      const response = await productApi.getProduct(id);

      commit('GET_PRODUCT_SUCCESS', response.data);
    } catch (error) {
      commit('GET_PRODUCT_ERROR', error.response);
    }
  },
  async addProduct({ commit }, body) {
    try {
      commit('ADD_PRODUCT_LOADING');

      const response = await productApi.addProduct(body);

      commit('ADD_PRODUCT_SUCCESS', response.data);
    } catch (error) {
      commit('ADD_PRODUCT_ERROR', error.response);
    }
  },
  async deleteProduct({ commit }, id) {
    try {
      commit('DELETE_PRODUCT_LOADING');

      const response = await productApi.deleteProduct(id);

      commit('DELETE_PRODUCT_SUCCESS', response.data);
    } catch (error) {
      commit('DELETE_PRODUCT_ERROR', error.response);
    }
  },
  async updateProduct({ commit }, { id, body }) {
    try {
      commit('UPDATE_PRODUCT_LOADING');

      const response = await productApi.updateProduct(id, body);

      commit('UPDATE_PRODUCT_SUCCESS', response.data);
    } catch (error) {
      commit('UPDATE_PRODUCT_ERROR', error.response);
    }
  },
};
